import React, { useState } from 'react';
import Login from './components/Login';
import AgentDashboard from './components/agent/AgentDashboard';
import BookDashboard from './components/book/BookDashboard';
import CustomerView from './components/CustomerView';
import AdminDashboard from './components/admin/AdminDashboard';
import CustomerServiceView from './components/CustomerServiceView';

function App() {
  const [user, setUser] = useState(null);

  const handleLogout = () => {
    setUser(null);
  };

  if (!user) {
    return <Login onLogin={setUser} />;
  }

  if (user.role === 'admin') {
    return <AdminDashboard user={user} onLogout={handleLogout} />;
  }

  if (user.role === 'customer') {
    return <CustomerView user={user} onLogout={handleLogout} />;
  }

  if (user.role === 'customer_service') {
    return <CustomerServiceView user={user} onLogout={handleLogout} />;
  }

  if (user.role === 'book') {
    return <BookDashboard user={user} onLogout={handleLogout} />;
  }

  return <AgentDashboard user={user} onLogout={handleLogout} />;
}

export default App;
